<template>
	<div>
		<calculator1 v-if="!calculatorType" v-model="localData" :payableColor="payableColor" :pureTitle="pureTitle" :max="max" :paymentPeriod="paymentPeriod" />
		<calculator2 v-else-if="calculatorType === 1" v-model="localData" :payableColor="payableColor" :pureTitle="pureTitle" :max="max" :paymentPeriod="paymentPeriod" />
	</div>
</template>

<script>
	import { get } from 'vuex-pathify'

	export default {
		name: 'LoanCalculator',
		props: {
			value: { type: Object },
			payableColor: { type: String, default: 'secondary' },
			pureTitle: { type: String, default: 'خالص دریافتی' },
			max: { type: Number, default: 0 },
			paymentPeriod: { type: Number, default: 0 },
			panel: { type: String, default: 'landing' }
		},
		components: {
			'calculator1': () => import('@/components/LoanCalculator1'),
			'calculator2': () => import('@/components/LoanCalculator2'),
		},
		data: () => ({
			localData: { amount: 0 },
		}),
		computed: {
			...get('appSettings', [
				'landingSettings'
			]),
			...get('memberAppSettings', {
				memberSettings: 'settings'
			}),
			...get('agentAppSettings', {
				agentSettings: 'settings'
			}),
			calculatorType() {
				if (this.panel === 'member')
					return this.memberSettings?.calculatorType || 0
				else if (this.panel === 'agent')
					return this.agentSettings?.calculatorType || 0
				else if (this.panel === 'landing')
					return this.landingSettings?.calculatorType || 0

				return this.landingSettings?.calculatorType || 0
			},
		},
		mounted() {
		},
		watch: {
			value: {
				immediate: true,
				deep: true,
				handler(val, oldVal) {
					this.localData = val
				}
			},
			localData: {
				deep: true,
				handler(val, oldVal) {
					this.$emit('input', val)
				}
			}
		},
		methods: {

		}
	}
</script>

<style scoped></style>